export const updateSelectedJobType = (payload) => async dispatch => {
    dispatch({ type: 'UPDATE_SELECTED_JOB_TYPE', payload: payload });
  };